<template>
  <QingHeader />
  <main class="site-main">
    <router-view />
  </main>
  <QingFooter />
</template>

<script>
import QingHeader from '@/components/QingHeader';
import QingFooter from "@/components/QingFooter";

export default {
  name: 'App',
  components: {
    QingHeader,
    QingFooter
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

body, html {
  height: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
  outline: none;
}

ul, li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
